let errorsResolver = (rules) => {
    return (errors) => {
        errors.forEach(err => {
            switch (err.code) {
                case 'any.empty':
                    err.message = rules.required ? rules.required : err.message
                    break
                case 'any.required':
                    err.message = rules.required ? rules.required : err.message
                    break
                case 'any.only':
                    err.message = rules.values ? rules.values : err.message
                    break
                case 'any.invalid':
                    err.message = rules.invalid ? rules.invalid : err.message
                    break
                case 'any.ref':
                    err.message = rules.ref ? rules.ref : err.message
                    break
                case 'string.empty':
                    err.message = rules.required ? rules.required : err.message
                    break
                case 'string.base':
                    err.message = rules.required ? rules.required : err.message
                    break
                case 'string.min':
                    err.message = rules.min ? rules.min : err.message
                    break
                case 'string.max':
                    err.message = rules.max ? rules.max : err.message
                    break
                case 'string.pattern.base':
                    err.message = rules.pattern ? rules.pattern : err.message
                    break
                case 'date.format':
                    err.message = rules.dateFormat ? rules.dateFormat : err.message
                    break
                case 'date.base':
                    err.message = rules.dateRequired ? rules.dateRequired : err.message
                    break
                case 'date.less':
                    err.message = rules.dateLess ? rules.dateLess : err.message
                    break
                case 'date.greater':
                    err.message = rules.dateGreater ? rules.dateGreater : err.message
                    break
                case 'date.min':
                    err.message = rules.dateMin ? rules.dateMin : err.message
                    break
                case 'date.max':
                    err.message = rules.dateFormat ? rules.dateFormat : err.message
                    break
                case 'string.email':
                    err.message = rules.email ? rules.email : err.message
                    break
                case 'number.precision':
                    err.message = rules.precision ? rules.precision : err.message
                    break;
                case 'number.base':
                    if (rules.numberBase) err.message = rules.numberBase
                    if (rules.number) err.message = rules.number
                    break
                case 'number.integer':
                    if (rules.numberInteger) err.message = rules.numberInteger
                    if (rules.number) err.message = rules.number
                    break;
                case 'number.unsafe':
                    err.message = rules.numberUnsafe ? rules.numberUnsafe : err.message
                    break
                case 'number.max':
                    if (rules.numberMax) err.message = rules.numberMax
                    if (rules.max) err.message = rules.max
                    break
                case 'number.min':
                    err.message = rules.numberMin ? rules.numberMin : err.message
                    break
                case 'number.greater':
                    err.message = rules.numberGreater ? rules.numberGreater : err.message
                    break
                case 'number.less':
                    if (rules.numberLess) err.message = rules.numberLess
                    if (rules.less) err.message = rules.less
                    break
                case 'array.min':
                    err.message = rules.invalid ? rules.invalid : err.message
                    break
                case 'array.max':
                    err.message = rules.arrayMax ? rules.arrayMax : err.message
                    break
                case 'array.includesRequiredUnknowns':
                    err.message = rules.includesRequiredUnknowns ? rules.includesRequiredUnknowns : err.message
                    break
                case 'object.base':
                    err.message = rules.objectBase ? rules.objectBase : err.message
                    break

                default:
                    break
            }
        })
        return errors
    }

}

export default errorsResolver
